import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/caikuma_running.png'


const _withScopeId = n => (_pushScopeId("data-v-c03c01d0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "position-relative mascot-outer" }
const _hoisted_2 = { class: "mt-2 stepbar" }
const _hoisted_3 = { class: "bar" }

import { computed } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'StepBar',
  props: {
  maxValue: {
    type: Number,
    required: true
  },
  currentValue: {
    type: Number,
    required: true
  },
  reverse: {
    type: Boolean,
    default: false
  }
},
  setup(__props) {

const props = __props;



const mascotImageStyle = computed(() => {
  const left = `${(props.currentValue - 1) * (100 / (props.maxValue - 1))}%`;
  return {
    left: left,
    marginLeft: "-1rem",
    width: "2rem",
    bottom: "0"
  };
});
const barStyle = computed(() => {
  const width = `${(props.currentValue - 1) * (100 / (props.maxValue - 1))}%`;
  return {
    width: width
  };
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("img", {
        class: "position-absolute",
        src: _imports_0,
        style: _normalizeStyle(mascotImageStyle.value)
      }, null, 4)
    ]),
    _createTextVNode(),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: "active",
          style: _normalizeStyle(barStyle.value)
        }, null, 4)
      ])
    ])
  ]))
}
}

})